import { object, string, } from 'yup';
export const CUSTOM_DOMAIN_REGEX = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
export const CUSTOM_DOMAIN_INVALID_MESSAGE = `Domain must only include domain name and TLD (e.g. example.com). (Do not include https://)`;
export const customDomainUpdateSchema = object({
    domain: string().matches(CUSTOM_DOMAIN_REGEX, {
        excludeEmptyString: true,
        message: CUSTOM_DOMAIN_INVALID_MESSAGE,
    }).trim().lowercase().nullable().defined(),
});
//# sourceMappingURL=customDomain.js.map